import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProjectChangeRequestComponent } from './project-change-request.component';
import { CanDeactivateService } from 'app/services/can-deactivate.service';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: ProjectChangeRequestComponent,
        canDeactivate: [CanDeactivateService]
      }
    ],
    data: {
      allowedRoles: ['pmo', 'admin', 'pm', 'guest']
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProjectChangeRequestRoutingModule { }